<!-- <div class="modal-header align-items-center">
  <h1 class="modal-title">Upload Progress</h1>
</div> -->

<div class="modal-body">
  <div class="info">
    <h1>{{ content.heading }}</h1>
    <div class="lh-lg d-flex align-items-center">
      <i
        class="material-icons me-1 mi-18"
        [ngClass]="{
          'text-primary': content.icon === 'info',
          'text-danger': content.icon === 'error',
          'text-success': content.icon === 'done'
        }"
        >{{ content.icon }}</i
      >
      {{ content.info }}
    </div>
  </div>
  <!-- Show animated progress bar while uploading -->
  <ngb-progressbar
    *ngIf="showProgress"
    class="w-100 bg-light"
    [ngClass]="{ loading: !showProgress }"
    height="1.8rem"
    [type]="progressType$ | async"
    [animated]="true"
    [striped]="true"
    [value]="progress$ | async"
  >
    <ng-container>
      <i>{{ progressText$ | async }}</i>
    </ng-container>
  </ngb-progressbar>

  <!-- Show static status when done (failed or completed) -->
  <div
    *ngIf="!showProgress"
    class="w-100 bg-light d-flex align-items-center justify-content-center"
    style="height: 1.8rem; border-radius: 0.375rem"
    [ngClass]="{
      'bg-danger text-white': (progressType$ | async) === 'danger',
      'bg-success text-white': (progressType$ | async) === 'success'
    }"
  >
    <span class="fw-bold">{{ progressText$ | async }}</span>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="close(true)" [disabled]="!done">
    Close
  </button>
</div>
